<template>
	<section ref="qrPanel" class="qr-section">
		<client-only>
			<div class="qr-panel">
				<div class="row">
					<form class="booking bookForm">
						<div class="columns column4">
							<date-picker
								v-model:value="state.arrival"
								:clearable="false"
								:disabled-date="disableArrivalDates"
								value-type="format"
								format="YYYY-MM-DD"
								:placeholder="$t('checkIn')"
								:lang="datepickerLang"
								@pick="pickArrival"
							/>
						</div>
						<div class="columns column4">
							<date-picker
								v-model:value="state.departure"
								:open="state.openDeparture"
								:disabled-date="disableDepartureDates"
								value-type="format"
								format="YYYY-MM-DD"
								:placeholder="$t('checkOut')"
								:default-value="state.pickedArrivalDate ?? new Date()"
								:lang="datepickerLang"
								@open="state.openDeparture = true"
								@close="state.openDeparture = false"
							/>
						</div>
						<div class="columns column4">
							<book-button
								class="button book-now cta qr"
								:arrival="state.arrival"
								:departure="state.departure"
							>
								{{ bookingForm.availability }}
							</book-button>
						</div>
					</form>
				</div>
				<div class="row">
					<div class="columns column12 benefits">
						<span>
							<strong>{{ bookingForm.benefitsContent }}</strong>
						</span>
						<span v-for="benefit in bookingForm.benefit" :key="benefit.ID">
							<font-awesome-icon :icon="`fa fa-check`" size="1x" />
							{{ benefit.content }}
						</span>
					</div>
				</div>
			</div>
		</client-only>
	</section>
</template>

<script setup>
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import datePickerTranslations from '~/i18n/datePicker.ts';

const { locale } = useI18n();

defineProps({
	bookingForm: { type: Object, default: () => ({}) },
});

const state = reactive({
	arrival: null,
	departure: null,
	openDeparture: false,
	pickedArrivalDate: null,
});

const qrPanel = ref(null);

const datepickerLang = computed(() => datePickerTranslations[locale] ?? datePickerTranslations.en);

const pickArrival = (date) => {
	state.departure = '';
	state.pickedArrivalDate = date;
	state.openDeparture = true;
};

const disableArrivalDates = (date) => {
	const today = new Date();

	return date < today.setDate(today.getDate() - 1);
};

const disableDepartureDates = (date) => {
	if (!state.pickedArrivalDate) {
		return disableArrivalDates(date);
	}

	return date <= state.pickedArrivalDate;
};

onMounted(() => {
	qrPanel.value.classList.add('mounted');
});
</script>

<style>
.mx-datepicker {
	width: 100%;
}

.mx-input {
	margin: 3px 0 !important;
	width: 100% !important;
	padding: 15px 40px 15px 0 !important;
	height: 50px !important;
	border: none !important;
	border-radius: 0 !important;
	border-bottom: 1px solid #03122f !important;
	background: none !important;
	box-shadow: none !important;
	color: var(--body-color) !important;
	font-weight: 600 !important;
	font-size: 18px !important;
}
</style>

<style lang="scss" scoped>
.qr-section {
	text-align: center;
	margin: 0 auto;
	position: absolute;
	bottom: 50px;
	left: 0;
	right: 0;
	padding: 0;
	float: left;
	width: 100%;
	max-width: 860px;
	z-index: 10;
}

.qr-panel {
	float: none;
	padding: 10px;
	width: 100%;
	margin: 0 auto;
	display: inline-block;
	position: relative;
	z-index: 2;
	text-align: center;
	background: rgb(255 255 255 / 80%);
	backdrop-filter: blur(38px);

	.row {
		width: 100%;

		&:last-child {
			padding: 15px 20px;
			font-size: 14px;

			.column12 {
				text-align: left;
			}

			span {
				margin: 0 30px 0 0;
			}
		}
	}

	.columns {
		padding: 0;
	}

	form {
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: space-between;

		.columns {
			padding: 10px 20px;
			width: 32%;

			&:last-child {
				width: 36%;
			}
		}
	}
}

.qr-panel input,
.qr-panel select {
	margin: 3px 0 !important;
	width: 100% !important;
	padding: 15px 40px 15px 0 !important;
	height: 50px !important;
	border-bottom: 1px solid #03122f !important;
}

.qr-panel .button {
	padding: 14px 10px !important;
	text-transform: uppercase;
	border: none !important;
	vertical-align: top;
	width: 100%;
}

.benefits {
	font-size: 13px;
	font-weight: 500;

	svg {
		color: var(--header-color);
		margin: 0 5px 0 0;
	}

	strong {
		color: var(--header-color);
	}
}
</style>
